import {
  tysonsHome,
  tysonsRecruit,
  tysonsRecruitForm,
  tysonsRecruitFormJa,
  tysonsRecruitInterview,
  tysonsBusiness
} from './constants/page'
import { accessCookie } from './lib/cookie'
import businessAnim, { setSean1 } from './lib/business-anim'
import debounce from 'throttle-debounce/debounce'
import 'jquery-datetimepicker'
import 'bootstrap-sass/assets/javascripts/bootstrap/tab'

accessCookie('tysons')

// newsletterページ。loading画像置き換え
$('.alo_em_widget_loading img').html(function () {
  const path = '/wp-content/themes/build/images/common/loader.gif'
  $(this).attr('src', path)
})

$('.js-tel-tysons-control').tewrap({
  phoneNumber: '03‐5479‐0327'
})

// TYSONS HOME
if (tysonsHome) {
  // console.log('home')
  // tysonsトップ専用。
  $('.js-scrollchecker-tysons').scrollchecker({
    fixedPosition: $('.js-loaded').height() - 50,
    fixedClass: 'is-fixed',
    fixedAfterClass: 'is-fixed-after'
  })
  // http://getbootstrap.com/javascript/#collapse
  $('.s-Tysons.p-Home #js-navbar').on('hidden.bs.collapse', function () {
    $('.ty-Navbar-header').removeClass('collapse-open')
  })
  $('.s-Tysons.p-Home #js-navbar').on('show.bs.collapse', function () {
    $('.ty-Navbar-header').addClass('collapse-open')
  })
}

// Recruit
if (tysonsRecruit) {
  $('.recruit-WorkFeild-tab a').click(function (e) {
    e.preventDefault()
    $(this).tab('show')
  })
}

// Recruit interview
if (tysonsRecruitInterview) {
  // console.log('recruit interview')

  $('.js-slickInterview').slick({
    infinite: false,
    dots: true,
    slidesToShow: 4,
    speed: 300,
    arrows: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  })
}

// Recruit Form
if (tysonsRecruitForm) {
  // console.log('recruit form')
  let lang

  if (tysonsRecruitFormJa) {
    // console.log('recruit form ja')
    lang = 'ja'
    $('#zip').keyup(function (event) {
      AjaxZip3.zip2addr(this, '', 'address', 'address')
    })
  } else {
    // console.log('recruit form en')
    lang = 'en'
  }

  $('input#birthday').datetimepicker({
    lang: lang,
    timepicker: false,
    format: 'Y/m/d',
    startDate: '1980/4/01',
    yearStart: 1960,
    yearEnd: 2010
  })

  $('input#start').datetimepicker({
    lang: lang,
    timepicker: false,
    format: 'Y/m/d',
    minDate: 0,
    weeks: true,
    yearStart: 2015,
    yearEnd: 2025
  })

  $('input#visa_expiration_date').datetimepicker({
    lang: lang,
    timepicker: false,
    format: 'Y/m/d',
    startDate: '2018/4/01',
    yearStart: 1960,
    yearEnd: 2010
  })
}

if (tysonsBusiness) {
  setSean1()

  window.onresize = debounce(300, event => {
    setSean1()
  })

  businessAnim()

  $('.js-slickBusiness').slick({
    speed: 300,
    arrows: false,
    infinite: false,
    dots: false,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 2
        }
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/js/tysons.js